Belimo.Modal = {
    open(content, buttons, config = {}) {
        $(document).trigger('modal-on', [content, buttons, config]);
    },
    close() {
        $(document).trigger('modal-off');
    },
    update(content, buttons, config = {}) {
        $(document).trigger('modal-update', [content, buttons, config]);
    },
    updateButtons(buttons) {
        $(document).trigger('modal-update-buttons', [buttons]);
    },
    prepend(content) {
        $(document).trigger('modal-prepend', [content]);
    },
    find(selector) {
        return $('.modal .modal-content').find(selector);
    }
};
